import Mycomplaintsview from "../../../jsx/components/Dashboard/MyComplaints/mycomplaintsview";

const MyComplaintsViewWrapper = () => {
  return <Mycomplaintsview />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(MyComplaintsViewWrapper);
